import React from 'react';
import { Text } from 'mintel-react-ui';
import { Trans } from 'react-i18next';

import useTranslation from '../../translations';
import PageWrapper from '../../PageWrapper';
import ThankYouMessage from '../SharedComponents';
import styles from './Step2Wrapper.scss';

export default ({ children }: { children: React.ReactNode }): JSX.Element => {
  const { t } = useTranslation();
  const stepNumber = 2;
  const totalSteps = 3;

  return (
    <PageWrapper>
      <div className={styles.root}>
        <Text.Heading2>{t('Registration')}</Text.Heading2>
        <Text.Body>
          <Trans>
            Step <b>{{ stepNumber }}</b> of <b>{{ totalSteps }}</b>
          </Trans>
        </Text.Body>
        <ThankYouMessage />
        {children}
      </div>
    </PageWrapper>
  );
};
